import React from "react";
import PropTypes from "prop-types";
import {
  PopHeader,
  InfoWrapper,
  QASection,
  DisplayFlexOkay,
  InfoContentWrapper,
  IconWrap,
} from "./styles";
import { GeneralButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import close from "../../../../../../../assets/icons/close-icon.svg";

class ViewAdditionalInfo extends React.Component {
  markup = (value) => {
    return {__html: value};
}

  render() {
    return (
      <InfoWrapper>
        <InfoContentWrapper>
          <IconWrap>
            <img src={close} onClick={this.props.handleOkay} alt="close"></img>
          </IconWrap>
          <PopHeader>
          {this.props.popUpInfo.name}
          </PopHeader>
          <QASection>
          <div dangerouslySetInnerHTML={this.markup(this.props.popUpInfo.description)}></div>
          </QASection>
          <DisplayFlexOkay>
            <GeneralButton 
              text = "OKAY"
              width = "150px"
              mobWidth = "100%"
              onClick={this.props.handleOkay}
            />
            </DisplayFlexOkay>
        </InfoContentWrapper>
      </InfoWrapper>
    );
  }
}

ViewAdditionalInfo.propTypes = {
  popUpInfo: PropTypes.object,
  handleOkay: PropTypes.func
}

export default ViewAdditionalInfo;
